import React from "react";
import Menu from "./sub-modules/menu";
import { HeaderContainer } from "./styled_components/containers";
import Profile from "./sub-modules/profile";
import Settings from "./sub-modules/settings";

function Header(props) {
  const { pupil } = props;

  return (
    <HeaderContainer>
      <Menu importantAssignment={props.importantAssignment} incompleteCount = {props.incompleteCount} hasClash={props.hasClash} clashCount={props.clashCount}/>
      <Profile name={pupil ? pupil.name : ""} />
      <Settings />
    </HeaderContainer>
  );
}

export default Header;
